export const sidebarOptions = [
  {name: 'Dashboard', icon: 'mdi-view-dashboard', path:'/dashboard', active: false, items: null},
  {
    name: 'Staff',
    icon: 'mdi-account',
    path: '/staff/list',
    section: 'staff',
    active: true,
    items: [
      {name: 'List', path: '/staff/list', icon:'mdi-format-list-text', iconSize:'small'},
      {name: 'Add member', path: '/staff/add', icon:'mdi-account-plus', iconSize: 'small'},
      //{name: 'Manage teams', path: '/staff/manage', icon:'mdi-account-plus'}
    ]
  },{
    name: 'Scouting',
    icon: 'mdi-account-tie-voice',
    path: '/scouting/list',
    section: 'scouting',
    active: true,
    items: [
      {name: 'List', path: '/scouting/list', icon:'mdi-format-list-text', iconSize: 'small'},
      {name: 'Add member', path: '/scouting/add', icon:'mdi-account-plus', iconSize: 'small'},
      //{name: 'Manage teams', path: '/staff/manage', icon:'mdi-account-plus'}
    ]
  },{
    name: 'Job market',
    icon: 'mdi-briefcase-account-outline',
    path: '/job-market/list',
    section: 'job-market',
    active: false,
    items: null
  },
];



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/data-iceverg.js